import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import classname from "classnames";
import withRouter from "../../Components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next";

const userRole = localStorage.getItem("userole_");

const Navbar = (props: any) => {

  const [manage, management] = useState<boolean>(false);
  const [user, usermanagement] = useState<boolean>(false);
  // const [ui, setui] = useState<boolean>(false);
  // const [app, setapp] = useState<boolean>(false);
  // const [email, setemail] = useState<boolean>(false);
  // const [ecommerce, setecommerce] = useState<boolean>(false);
  // const [crypto, setcrypto] = useState<boolean>(false);
  // const [project, setproject] = useState<boolean>(false);
  // const [task, settask] = useState<boolean>(false);
  // const [contact, setcontact] = useState<boolean>(false);
  // const [blog, setBlog] = useState<boolean>(false);
  // const [job, setJob] = useState<boolean>(false);
  // const [candidate, setCandidate] = useState<boolean>(false);
  // const [component, setcomponent] = useState<boolean>(false);
  // const [form, setform] = useState<boolean>(false);
  // const [table, settable] = useState<boolean>(false);
  // const [chart, setchart] = useState<boolean>(false);
  // const [icon, seticon] = useState<boolean>(false);
  // const [map, setmap] = useState<boolean>(false);
  // const [extra, setextra] = useState<boolean>(false);
  // const [invoice, setinvoice] = useState<boolean>(false);
  // const [auth, setauth] = useState<boolean>(false);
  // const [utility, setutility] = useState<boolean>(false);

  useEffect(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    var matchingMenuItem = null;
    var ul: any = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");

    let itemsArray = [...items];
    removeActivation(itemsArray);

    for (var i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));

    actiItems.forEach((item: any) => {
      const parent = item.parentElement

      if (item.classList.contains("dropdown-item")) {
        parent.classList.remove("active");
        const parent2 = parent.parentElement;
        parent2.classList.remove("active");

        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  const [itoggleLeftmenu, setitoggleLeftmenu] = useState<any>(false);

  return (
    <React.Fragment>
        <button
          type="button"
          className="btn btn-sm px-3 horMenuBtn font-size-14 d-lg-none header-item"
          data-toggle="collapse"
          onClick={()=>{setitoggleLeftmenu(!itoggleLeftmenu)}}
          data-target="#topnav-menu-content"
        >
          <i className="fa fa-fw fa-bars" />
        </button>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse isOpen={itoggleLeftmenu} className="navbar-collapse justify-content-start" id="topnav-menu-content">
              <ul className="navbar-nav">
              
                {/* Admin menus here */}
                {localStorage.getItem("userole_") === "adm" && (
                  <>
                    <li className="nav-item">
                      <Link to="/" className="nav-link" onClick={() => { usermanagement(false); management(false); }}>
                        <i className="bx bx-home-circle me-2"></i>
                        {props.t("Home")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/adashboard" className="nav-link" onClick={() => { usermanagement(false); management(false); }}>
                        <i className="bx bx-bar-chart-square me-2"></i>
                        {props.t("Dashboard")}
                      </Link>
                    </li>

                    <li className="nav-item dropdown dropdownIssue">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          management(!manage);
                          usermanagement(false);
                        }}
                        to="admincategories"
                      >
                        <i className="bx bx-food-menu me-2"></i>
                        {props.t("Management")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: manage })}
                      >
                        <Link to="/admincategories" className="dropdown-item" onClick={() => management(false)} >
                          <i className="bx bx-hive me-2"></i>
                          {props.t("Category Management")}
                        </Link>
                        <Link to="/domains" className="dropdown-item" onClick={() => management(false)}>
                          <i className="bx bx-globe me-2"></i>
                          {props.t("Domains Management")}
                        </Link>
                        <Link to="/adminpacks" className="dropdown-item" onClick={() => management(false)}>
                          <i className="bx bx-package me-2"></i>
                          {props.t("Platform Packages")}
                        </Link>
                        <Link to="/partnerplansubmissions" className="dropdown-item" onClick={() => management(false)}>
                          <i className="bx bx-file-blank me-2"></i>
                          {props.t("Partner Plan Submissions")}
                        </Link>
                        <Link to="/adminvalues" className="dropdown-item" onClick={() => management(false)}>
                          <i className="bx bx-package me-2"></i>
                          {props.t("Admin Values")}
                        </Link>
                        <Link to="/aorders" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-shopping-bag me-2"></i>
                          {props.t("All Orders")}
                        </Link>
                        <Link to="/adminfeedback" className="dropdown-item" onClick={() => management(false)}>
                          <i className="bx bx-comment-dots me-2"></i>
                          {props.t("Customer Feedbacks")}
                        </Link>
                      </div>
                    </li>


                    <li className="nav-item dropdown dropdownIssue">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          usermanagement(!user);
                          management(false);
                        }}
                        to="adminexperts"
                      >
                        <i className="bx bx-user-pin me-2"></i>
                        {props.t("User Management")}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: user })}
                      >
                        <Link to="/adminexperts" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-user-circle me-2"></i>
                          {props.t("Experts Management")}
                        </Link>
                        <Link to="/admincustomers" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-group me-2"></i>
                          {props.t("Customers Management")}
                        </Link>
                        <Link to="/admincompanies" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-buildings me-2"></i>
                          {props.t("All Companies")}
                        </Link>
                        <Link to="/abookings" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-calendar-event me-2"></i>
                          {props.t("Customer Bookings")}
                        </Link>
                        <Link to="/adminpartners" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-user-pin me-2"></i>
                          {props.t("Partner Management")}
                        </Link>
                        <Link to="/adminemployees" className="dropdown-item" onClick={() => usermanagement(false)}>
                          <i className="bx bx-id-card me-2"></i>
                          {props.t("Employee Management")}
                        </Link>
                      </div>
                    </li>

                    <li className="nav-item">
                      <Link to="/adminAssignments" className="nav-link" onClick={() => { usermanagement(false); management(false); }}>
                        <i className="bx bx-task me-2"></i>
                        {props.t("Assignments")}
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/marketing" className="nav-link" onClick={() => { usermanagement(false); management(false); }}>
                        <i className="bx bx-envelope me-2"></i>
                        {props.t("Marketing")}
                      </Link>
                    </li>
                  </>
                )}

                {/* Expert Menus here */}
                {localStorage.getItem("userole_") === "exp" && (
                  <>
                    <li className="nav-item">
                      <Link to="/edashboard" className="nav-link">
                        <i className="bx bx-home-circle me-2"></i>
                        {props.t("Dashboard")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/ebookings" className="nav-link">
                        <i className="bx bx-calendar me-2"></i>
                        {props.t("My Bookings")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/availability" className="nav-link">
                        <i className="bx bx-calendar-event me-2"></i>
                        {props.t("Availability")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/package" className="nav-link">
                        <i className="bx bx-package me-2"></i>
                        {props.t("My Packages")}
                      </Link>
                    </li>
                  </>
                )}

                {/* Customer menus here */}
                {localStorage.getItem("userole_") === "cst" && (
                  <>
                    <li className="nav-item">
                      <Link to="/" className="nav-link">
                        <i className="bx bx-home-circle me-2"></i>
                        {props.t("Home")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/cdashboard" className="nav-link">
                        <i className="bx bx-home-circle me-2"></i>
                        {props.t("Dashboard")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/corders" className="nav-link">
                        <i className="bx bx-user-check me-2"></i>
                        {props.t("Orders & Purchases")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/cbookings" className="nav-link">
                        <i className="bx bx-calendar-event me-2"></i>
                        {props.t("My Bookings with Experts")}
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/billing-history" className="nav-link">
                        <i className="bx bx-history me-2"></i>
                        {props.t("Billing History")}
                      </Link>
                    </li> */}
                    {/* <li className="nav-item">
                    <Link to="/cprofile" className="nav-link">
                      <i className="bx bx-user me-2"></i>
                      {props.t("Customer Profile")}
                    </Link>
                  </li> */}

                  </>
                )}

                {/* Partner menus here */}
                {localStorage.getItem("userole_") === "prt" && (
                  <>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="bx bx-home-circle me-2"></i>
                      {props.t("Home")}
                    </Link>
                  </li>                  
                  </>
                )}

                {/* Employee menus here */}
                {localStorage.getItem("userole_") === "emp" && (
                  <>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i className="bx bx-home-circle me-2"></i>
                      {props.t("Home")}
                    </Link>
                  </li>                  
                  </>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};
export default withRouter(withTranslation()(Navbar));